import {Injectable} from "@angular/core";
import {Addons} from "@models/addons.interface";

@Injectable()
export class AddonService {

  getInsurance(addon: Addons) {
    return addon &&  addon.insurance ? {
      price: addon.insurance.price,
      id: addon.insurance.info.id,
      amount_high: addon.insurance.info.amount_high,
      deductible: addon.insurance.info.deductible
    } : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/addon.service.ts